




import { Component, Prop, Vue } from 'vue-property-decorator';
import L from 'leaflet';
import 'leaflet-pulse-icon';
import 'leaflet-pulse-icon/src/L.Icon.Pulse.css';
import 'leaflet.locatecontrol';

@Component
export default class GeoLocation extends Vue {

    get config() {
        return this.$store.state.config;
    }

    get map() {
        return this.$store.state.map;
    }

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        if (action.type === 'initGeoLocation') {
            this.initGeoLocation();
        }
    });

    public initGeoLocation() {
        console.log('GeoLocation: initGeoLocation()');
        // @ts-ignore - pulse icon has no typedefs
        const pulsingIcon = L.icon.pulse({
            iconSize: [this.config.locationSize, this.config.locationSize],
            color: this.config.locationColor,
            fillColor: this.config.locationColor,
        });

        // @ts-ignore - no typedefs
        const locationControl = L.control.locate({
            clickBehavior: {
                inView: 'stop',
                outOfView: 'setView',
                inViewNotFollowing: 'inView',
            },
            // enableHighAccuracy: true,
            drawCircle: false,
            cacheLocation: true,
            icon: 'fa fa-crosshairs',
            markerStyle: {
                icon: pulsingIcon,
            },
            markerClass: L.Marker,
            keepCurrentZoomLevel: false,
            locateOptions: {
                maxZoom: this.config.locationZoom,
                minZoom: this.config.locationZoom,
            },
        });

        if (navigator.geolocation) {
            locationControl.addTo(this.map);
        }
    }

    // Unused parts of the old GeoLocationMgr

    // var _toggleGeoLocateControl = function () {
    //     if (RemapState.getDeviceMode() == "mobile") {
    //         _locationControl.addTo(_map);
    //     } else {
    //         _locationControl.remove();
    //     }
    // };

    // var _getLocation = function () {
    //     if (_locationControl && _locationControl._marker && _locationControl._marker._latlng) {
    //         _location = _locationControl._marker._latlng;
    //         return _location;
    //     }
    //     return null;
    // };

    // var _checkLocation = function () {
    //     var l = _getLocation();
    //     if (l) {
    //         if (!_map.getBounds().contains(l)) {
    //             setTimeout(function () {
    //                 _disableLocation();
    //             }, RN_Config.locationTimeout);
    //         }
    //     }
    // };

    // var _disableLocation = function () {
    //     var l = _getLocation();
    //     if (l) {
    //         if (!_map.getBounds().contains(l)) {
    //             _locationControl.stop();
    //         }
    //     }
    // };

    // /*
    //  * UNUSED - gets nearby property ids within 1000m if location is active
    //  */
    // var _getNearbyProperties = function () {
    //     console.log("_getNeabyProperties");
    //     var l = _getLocation();
    //     var distance = 1000;
    //     if (l) {
    //         console.log(l);
    //         var query = L.esri.query({
    //             url: RN_Config.ListingsPointLayer.url_in,
    //             proxy: RN_Config.proxy.url
    //         });

    //         query.nearby(l, distance).ids(function (error, ids, response) {
    //             if (!error) {
    //                 console.log(response);
    //                 var filteredIds = {};
    //                 for (var i = 0; i < ids.length; i++) {
    //                     console.log(ids[i]);
    //                     filteredIds[ids[i]] = 1;
    //                 }
    //             }
    //             else {
    //                 console.log(error);
    //                 ErrorMgr.logError("failed to get nearby locations:" + error);
    //             }
    //         });
    //     }
    // };

    public mounted() {
        console.log('GeoLocation: mounted()');
    }
}

